import React from 'react';
import { Link, Img } from 'gatsby';
import PreviewCompatibleImage from '../../../PreviewCompatibleImage';

import classes from './card.module.scss';

const Card = (props) => {
  const bgColor = props.bgColor || '#fff';
  const textColor = props.textColor || '#363636';
  const cardTemplate = (
    <div
      className="card"
      style={{ backgroundColor: bgColor, color: textColor, ...props.style }}
    >
      {/* Card Image */}
      <div className="card-image">
        <PreviewCompatibleImage
          imageInfo={{
            alt: 'Category Image',
            image: props.image,
            aspectRatio: 4 / 3,
          }}
        ></PreviewCompatibleImage>
      </div>
      <div className="card-content">
        <p className="title is-4" style={{ color: textColor }}>
          {props.title}
        </p>
        {props.subtitle && (
          <p className="subtitle is-6" style={{ color: textColor }}>
            {props.subtitle}
          </p>
        )}
      </div>
      {props.link && (
        <footer className="card-footer">
          <div className="card-footer-item">More Info →</div>
        </footer>
      )}
    </div>
  );

  const _linkWrapper = (card) => {
    if (props.link) {
      return <Link to={props.link}>{card}</Link>;
    }

    return card;
  };

  return (
    <div
      className={`column is-4 card-hover ${
        props.link && classes.cardHoverable
      }`}
    >
      {_linkWrapper(cardTemplate)}
    </div>
  );
};

export default Card;
